/**
 * @author Yaochao
 * @date 2022/4/26 20:21
 * @description
 */
import React from 'react'
import IconRecycle from "../../iconfont/recycle/recycle";
import IconDeleteSelected from "../../iconfont/deleteSelected/deleteSelected";

/**
 *
 * @param onChange 当Tab切换是触发，接收的是当前Tab的index
 * @param onDelete 当Tab删除时触发，接收的时当前Tab的index
 * @param activeIndex 当前选中的Tab的index
 * @param delable Tab是否可删除，Boolean
 * @returns {*}
 * @constructor
 */
const ZKSideTab = (props) => {

    let {onChange, onDelete, activeIndex, delable} = props;

    let tabItemClick = (index) => {
        //通知onChange事件
        if (onChange) {
            onChange(index);
        }
    };

    let tabItemDelete = (index) => {
        //通知onChange事件
        if (index <= activeIndex) {
            let currIndex = activeIndex - 1;
            if (currIndex < 0) {
                currIndex = 0;
            }
            if (onChange) {
                onChange(currIndex);
            }
        }
        //通知onDelete事件
        if (onDelete) {
            onDelete(index);
        }
    };

    let getItemNum = () => {
        let count = 0;
        React.Children.map(props.children, (child, index) => {
            if (child.props.typeName == 'ZKSideTabItem') {
                count++;
            }
        })
        return count;
    };

    return (
        <div className="zkSideTab">
            <div className='zkSideTabWraper'>
                <ul className="zkSideTabItemList">
                    {
                        React.Children.map(props.children, (child, index) => {
                            if (child.props.typeName == 'ZKSideTabItem') {
                                return <li onClick={() => {
                                    tabItemClick(index)
                                }} className={activeIndex == index ? 'zkSideTabItem active' : 'zkSideTabItem'}>
                                    {
                                        child
                                    }
                                    {
                                        getItemNum() > 1 && delable ?
                                            <div className={'zkSide-delIcon'} onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                tabItemDelete(index);
                                            }}><span>{activeIndex == index ? <IconDeleteSelected/> :
                                                <IconRecycle/>}</span></div> : ''
                                    }
                                </li>
                            }
                        })
                    }
                </ul>
                {
                    React.Children.map(props.children, (child, index) => {
                        if (child.props.typeName == 'ZKSideTabAdd') {
                            return child;
                        }
                    })
                }
            </div>
            <div className='zkSideTabPane'>
                {
                    React.Children.map(props.children, (child, index) => {
                        if (child.props.typeName == 'ZKSideTabPane') {
                            return child;
                        }
                    })
                }
            </div>
        </div>
    )
};

export default ZKSideTab;